import { useTranslation } from 'react-i18next';

import { Card, CardBody, CardExpandToggler } from '../../../../components/card/card.jsx';
import Loading from '../../../../components/Shared/Loader/Loading.js';
import { useState } from 'react';
import Bar from '../../../dashboard/Bar.jsx';
import Area from '../../../dashboard/Area.jsx';
import Pie from '../../../dashboard/Pie.jsx';
import Line from '../../../dashboard/Line.jsx';
import Breadcrumb from '../../../../components/Shared/Breadcrumb.js';

const APDashboard = () => {
  const { t } = useTranslation();

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const [pieChartData, setPieChartData] = useState({
    labels: ['مورد 1', 'مورد 2', 'مورد 3', 'مورد 4'],
    series: [40, 30, 20, 10], // نسب المدفوعات لكل مورد
  });

  const [barChartData, setBarChartData] = useState({
    title: 'المصروفات حسب الشهر',
    categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو'],
    // options: {
    //   xaxis: {
    //     categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو'],
    //   },
    // },
    series: [
      {
        name: 'المصروفات',
        data: [1000, 1200, 1100, 1500, 1300, 1400], // المصروفات الشهرية
      },
    ],
  });

  const [lineChartData, setLineChartData] = useState({
    title: 'المدفوعات والمصروفات معًا',
    categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو'],

    series: [
      {
        name: 'المدفوعات',
        data: [2000, 1500, 1800, 2200, 2500, 2700], // المدفوعات الشهرية
      },
      {
        name: 'المصروفات',
        data: [1000, 1200, 1100, 1500, 1300, 1400], // المصروفات الشهرية
      },
    ],
  });

  // const [lineChartData2, setLineChartData2] = useState({
  //   options: {
  //     chart: {
  //       type: 'line',
  //     },
  //     xaxis: {
  //       categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو'],
  //     },
  //     title: {
  //       text: 'المدفوعات والمصروفات معًا',
  //       align: 'center',
  //     },
  //     colors: ['#34c38f', '#ffbb33'], // ألوان المدفوعات والمصروفات
  //   },
  //   series: [
  //     {
  //       name: 'المدفوعات',
  //       data: [2000, 1500, 1800, 2200, 2500, 2700], // المدفوعات الشهرية
  //     },
  //     {
  //       name: 'المصروفات',
  //       data: [1000, 1200, 1100, 1500, 1300, 1400], // المصروفات الشهرية
  //     },
  //   ],
  // });

  const [comboChartData2, setComboChartData2] = useState({
    title: 'المدفوعات والمصروفات',
    categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو'],

    series: [
      {
        name: 'المدفوعات',
        type: 'column',
        data: [2000, 1500, 1800, 2200, 2500, 2700],
      },
      {
        name: 'المصروفات',
        type: 'column',
        // type: 'line',
        data: [1000, 1200, 1100, 1500, 1300, 1400],
      },
    ],
  });

  const [areaChartData2, setAreaChartData2] = useState({
    categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو'],
    // options: {

    //   xaxis: {
    //     categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو'],
    //   },

    //  },
    series: [
      {
        name: 'المدفوعات',
        data: [1000, 2500, 3500, 4500, 6000, 7000],
      },
    ],
  });

  const [pieChartData2, setPieChartData2] = useState({
    labels: ['مدفوعات نقدية', 'مدفوعات عبر الإنترنت', 'مدفوعات أخرى'],
    series: [50, 30, 20],
  });
  return (
    <div>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
            link: null,
          },
        ]}
      />
      <Loading loading={false} error={null}>
        <>
          {/* <div className="row">
            <div className="col-lg-4">
              <Card className="mb-3 ">
                <CardBody>
                  <div className="d-flex fw-bold  mb-3">
                    <span className="flex-grow-1 t">إجمالي عدد القيود</span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <h1 className="mb-0 ps-4 text-purple ">
                        <CountUp end={94} duration={2.5} />
                      </h1>
                    </div>
                    <div className="col-5 text-center">
                      <div className="mt-n2 ps-4">
                        <Icon
                          icon="line-md:check-list-3-twotone"
                          className="me-2 text-purple  "
                          style={{ fontSize: '5rem' }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-lg-4">
              <Card className="mb-3 ">
                <CardBody>
                  <div className="d-flex fw-bold  mb-3">
                    <span className="flex-grow-1 "> القيود المرحلة</span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <h1 className="mb-0 ps-4 text-success ">
                        <CountUp end={76} duration={2.5} />
                      </h1>
                    </div>
                    <div className="col-5 text-center">
                      <div className="mt-n2 ps-4">
                        <Icon
                          icon="ph:check-circle-duotone"
                          className="me-2 text-success  "
                          style={{ fontSize: '5rem' }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-lg-4">
              <Card className="mb-3">
                <CardBody>
                  <div className="d-flex fw-bold  mb-3">
                    <span className="flex-grow-1 ">القيود الغير مرحلة</span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <h1 className="mb-0 ps-4 text-danger">
                        <CountUp end={18} duration={2.5} />
                      </h1>
                    </div>
                    <div className="col-5 text-center">
                      <div className="mt-n2 ps-4">
                        <Icon
                          icon="humbleicons:exclamation"
                          className="me-2 text-danger "
                          style={{ fontSize: '5rem' }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div> */}

          <div className="row g-3">
            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">توزيع المدفوعات حسب الموردين</span>
                    <CardExpandToggler />
                  </div>
                  <Pie labels={pieChartData.labels} series={pieChartData.series} height={400} />
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">{barChartData.title}</span>
                    <CardExpandToggler />
                  </div>
                  <Bar
                    categories={barChartData.categories}
                    series={barChartData.series}
                    height={400}
                  />
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">{lineChartData.title}</span>
                    <CardExpandToggler />
                  </div>

                  <Line categories={lineChartData.categories} series={lineChartData.series} />
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">المدفوعات والمصروفات</span>
                    <CardExpandToggler />
                  </div>

                  <Bar
                    categories={comboChartData2.categories}
                    series={comboChartData2.series}
                    height={400}
                  />
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">المدفوعات المتراكمة</span>
                    <CardExpandToggler />
                  </div>
                  <Area
                    categories={areaChartData2.categories}
                    series={areaChartData2.series}
                    // height={400}
                  />
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">نسب المدفوعات</span>
                    <CardExpandToggler />
                  </div>

                  <Pie labels={pieChartData2.labels} series={pieChartData2.series} height={500} />
                </CardBody>
              </Card>
            </div>
          </div>
        </>
      </Loading>
    </div>
  );
};

export default APDashboard;
